import { render, staticRenderFns } from "./CoozzyTwitterIcon.vue?vue&type=template&id=e53f9576&scoped=true"
import script from "./CoozzyTwitterIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyTwitterIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyTwitterIcon.vue?vue&type=style&index=0&id=e53f9576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53f9576",
  null
  
)

export default component.exports